import { useSelector } from "react-redux";

import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

import { HeaderButton } from "./headerButton.component";

export type HeaderButtonContainerProps = {
    icon: string;
    text: string;
    hover?: boolean;
    dropdown?: boolean;
    alerts?: number;
    invert?: boolean;
    link?: string;
    innerHTML?: string;
    hiddenText?: boolean;
    ariaLabel?: string;
};

const HeaderButtonContainer = (props: HeaderButtonContainerProps) => {
    const mobile = useSelector(HeaderSelectors.isMobile);
    const isClient = useIsClientSide();

    return (
        <HeaderButton
            {...props}
            invert={props.invert || (isClient && mobile)}
        >
            {props.innerHTML !== "" && props.innerHTML !== undefined && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: props.innerHTML
                    }}
                />
            )}
        </HeaderButton>
    );
};

export { HeaderButtonContainer };
